<div class="upload-card bg-body text-body border rounded-3 shadow-lg p-3"
     [class.upload-card--expanded]="expanded" [class.upload-card--minimized]="!expanded">
    <div class="d-flex justify-content-between align-items-start gap-2">
        <span class="fs-5 fw-semibold text-body-emphasis text-break">{{ card.title }}</span>
        <span class="d-inline-flex gap-1 flex-shrink-0">
            @if (!card.done && expanded) {
                <button type="button" class="btn btn-link btn-sm p-1 text-secondary text-decoration-none" title="Minimize" (click)="minimize.emit(card.id)">
                    <i class="fas fa-compress"></i>
                </button>
            }
            @if (!expanded) {
                <button type="button" class="btn btn-link btn-sm p-1 text-secondary text-decoration-none" title="Maximize" (click)="maximize.emit(card.id)">
                    <i class="fas fa-expand"></i>
                </button>
            }
            @if (card.done || !expanded) {
                <button type="button" class="btn btn-link btn-sm p-1 text-secondary text-decoration-none" title="Close" (click)="closeCard.emit(card.id)">
                    <i class="fas fa-xmark"></i>
                </button>
            }
        </span>
    </div>

    @if (expanded && displayLines.length) {
        <div class="mt-2">
            @for (line of displayLines; track $index) {
                <div class="lh-base text-break" [ngClass]="statusClass">{{ line }}</div>
            }
        </div>
    } @else {
        <div class="mt-1 fs-6" [ngClass]="statusClass">{{ statusLabel }}</div>
    }

    <div class="progress mt-3" role="progressbar" aria-label="Upload progress">
        <div [class]="progressBarClass" [style.width]="progressWidth"></div>
    </div>
</div>
